import React, { useState } from 'react';
import { useStyles } from './FaqDetails.styles';
import { IFaqListItem } from '../../../services/support/faq/supportFaq.types';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { sanitizeHtmlContent } from '../../../utils/reactQuillUtils'
import { IconButton } from '@mui/material';

interface FaqDetailsProps {
  deleteFunc: () => void;
  updateFunc: () => void;
  isAdminPermission: boolean
  faqProp: IFaqListItem;
}

export const FaqDetails: React.FC<FaqDetailsProps> = ({ faqProp, deleteFunc, updateFunc, isAdminPermission } ) => {
  const classes = useStyles();

  const [collapsed, setCollapsed] = useState<boolean>(true);

  return (
    <div className={classes.faqCardFlex} style={{ position: 'relative' }}>
      <div style={{ position: 'absolute', right: 0, cursor: 'pointer' }}>
        <IconButton onClick={() => setCollapsed(!collapsed)}>
          {collapsed && <ArrowDropDownIcon />}
          {!collapsed && <ArrowDropUpIcon />}
        </IconButton>
        {isAdminPermission && <>
          <IconButton onClick={updateFunc}><EditOutlinedIcon /></IconButton>
          <IconButton onClick={deleteFunc}><DeleteOutlineIcon /></IconButton>
        </>}
      </div>
      <p><strong>{faqProp.question}</strong></p>
      {!collapsed && <div className="ql-editor" dangerouslySetInnerHTML={{ __html: sanitizeHtmlContent(faqProp.answer) }}></div>}
    </div>
  );
};
